import React from 'react';
import { primaryBlue } from '../Styles/Colours';
import styles from './BackLink.module.css';
import { ArrowLeftIcon } from './Icons';
export var BackLink = function (props) {
    return (React.createElement("div", { className: styles.container, onClick: props.onClickBack },
        React.createElement("div", { className: styles.icon },
            React.createElement(ArrowLeftIcon, { size: '24', noPadding: true, color: primaryBlue })),
        React.createElement("div", { className: styles.text }, props.backLinkText)));
};
